import { render, staticRenderFns } from "./HCP_list_no_approve.vue?vue&type=template&id=6b321bd8&scoped=true"
import script from "./HCP_list_no_approve.vue?vue&type=script&lang=js"
export * from "./HCP_list_no_approve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b321bd8",
  null
  
)

export default component.exports